<div>
  <h2>{{ vendorFeedbackHeading }}</h2>
  <p-scrollpanel [style]="{ width: '100%', height: '150px' }">
    <div *ngFor="let item of vendorFeedbackObject">
      <p-rating
        [stars]="5"
        [readonly]="true"
        [(ngModel)]="item.score"></p-rating>

      <p class="feedback-notes">
        {{ item.notes }}
      </p>
      <div class="meta d-flex justify-content-between cstm-colm">
        <div class="reviewer-name d-flex align-items-center me-3">
          <span class="name">{{ item.createdBy }}</span>
        </div>
        <div class="d-flex date-switcher">
          <time class="me-3" *ngIf="item?.createdDate | hidedynamicsdate">{{
            item.createdDate | date: "MM-dd-yyyy"
          }}</time>
          <div
            class="form-group switcher feedback-switch"
            [hidden]="disabledToggle">
            <div class="form-check form-switch d-flex align-items-center m-0">
              <input
                class="form-check-input me-2"
                type="checkbox"
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                (click)="onDisabledFeedback($event, item)"
                [checked]="item.isVisible" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-scrollpanel>
</div>
